// config.js
const config = (() => {
    // Définissez vos variables globales ici
    const ENV = process.env.REACT_APP_ENV || 'dev';
    const BASE_URL = process.env.REACT_APP_BASE_URL || 'meoboard.dev.3.meosis.fr';
    
    const CUSTOM_COLORS = {
        mgray: "#eaeced",
        mdark: "#2f4250",
        mlime: "#8cc83c",
        morange: "#e89f3c",
        mgray2: "#bdc3c6",
        colorbutton: "#5A891B",
    }

    // Retourne un objet contenant les variables globales mais en lecture seule
    return {
        getEnv: () => ENV,
        getURL: (str) => {
            let url = 'https://';

            if (str === 'api') {
                url += BASE_URL + '/api/';
            } else if (str.startsWith('mf')) {
                let ext = str.split('_')[1];
                url += BASE_URL + '/meoboard/webroot/files/' + (ext ? ext + '/' : '');
            } else {
                url += BASE_URL;
            }
            return url;
        },
        getCustomColors: () => CUSTOM_COLORS,
        log: (value) => {
            if (ENV === 'dev') {
                console.trace(); // Affiche la trace complète dans la console

                const getCallerInfo = () => {
                    const err = new Error();
                    Error.captureStackTrace(err, getCallerInfo);

                    const stackLines = err.stack.split('\n');

                    for (let i = 2; i < stackLines.length; i++) {
                        if (stackLines[i].includes('at ')) {
                            const matchWithParentheses = stackLines[i].match(/\((.*):(\d+):(\d+)\)/);
                            if (matchWithParentheses) {
                                return `${matchWithParentheses[1]}:${matchWithParentheses[2]}`;
                            }
                            const matchWithoutParentheses = stackLines[i].match(/at (.*):(\d+):(\d+)/);
                            if (matchWithoutParentheses) {
                                return `${matchWithoutParentheses[1]}:${matchWithoutParentheses[2]}`;
                            }
                        }
                    }
                    return stackLines[2].trim();
                };

                const callerInfo = getCallerInfo();
                console.log(`${callerInfo}\n`, value);
            }
        },
        customLog: () => {
            if (ENV === 'prod') {
                // En prod, on remplace console.log par une fonction vide
                console.log = function() {
                    // Ne fait rien en prod
                };
            }
            // En dev, on laisse console.log tel quel
            
            return true;
        }       
    };
})();

export default config;